import { Injectable } from '@angular/core';
import { IBulkProfileResultModel } from '../entities-api/IBulkProfileResultModel';
import { IBulkProfileModel } from '../entities-api/IBulkProfileModel';
import { IGlobalEmployeeDetailGridDataModel } from '../entities-api/IGlobalEmployeeDetailGridDataModel';
import { IGlobalEmployeeDictionariesModel } from '../entities-api/IGlobalEmployeeDictionariesModel';
import { IGlobalEmployeeInfoModel } from '../entities-api/IGlobalEmployeeInfoModel';
import { IGlobalEmployeeOverrideModel } from '../entities-api/IGlobalEmployeeOverrideModel';
import { IUserFetchCriteriaModel } from '../entities-api/IUserFetchCriteriaModel';
import { IUserProfileDataModel } from '../entities-api/IUserProfileDataModel';
import { IRequest } from '../entities/request.interface';
import { BaseRepository } from './base.repository';
import { IAppcodeModel } from '../entities-api/IAppcodeModel';
import { IMfcodemodel } from '../entities-api/IMfcodemodel';
import { IContainerMappingFetchCriteriaModel } from '../entities-api/IContainerMappingFetchCriteriaModel';
import { IContainerMappingDetailGridDataModel } from '../entities-api/IContainerMappingDetailGridDataModel';
import { IGeocodemodel } from '../entities-api/IGeocodemodel';
import { IMfModel } from '../entities-api/IMfModel';
import { IBaseMappingFetchCriteriaModel } from '../entities-api/IBaseMappingFetchCriteriaModel';
import { IBaseMappingDetailGridDataModel } from '../entities-api/IBaseMappingDetailGridDataModel';

@Injectable()
export class UserRepository extends BaseRepository {
  getCurrentUserAsync(): Promise<IGlobalEmployeeInfoModel> {
    return this.get<IGlobalEmployeeInfoModel>('/api/ContainerMapping/Current');
  }

  getCurrentUserImage(id: string): Promise<XMLHttpRequest> {
    return this.get("api/User/image/" + id, { responseType: "blob" });
  }

  renewSession(): Promise<{}> {
    return this.get("api/User/RenewSession");
  }

  getNewOpmUpdatesAvailable(): Promise<boolean> {
    return this.get("api/User/GetNewOpmUpdatesAvailable");
  }

  //getAccessForContainerMapping(): Promise<boolean> {
    //return this.get("api/ContainerMapping/GetAccessForContainerMapping");
  //}

  getWriteAccessData(): Promise<boolean> {
    return this.get("api/ContainerMapping/GetWriteAccessData");
  }

  getReadOnlyAccessData(): Promise<boolean> {
    return this.get("api/ContainerMapping/GetReadOnlyAccessData");
  }

  getDQGateAccessData(): Promise<boolean> {
    return this.get("api/ContainerMapping/GetDQGateAccessData");
  }

  resetNewOpmUpdatesAvailable(): Promise<{}> {
    var request: IRequest = {
      Url: "api/User/ResetNewOpmUpdatesAvailable",
      Body: {}
    }
    return this.post(request);
  }

  getEnv(): Promise<string> {
    return this.get("api/ContainerMapping/GetEnv");
  }
  getUsers(filter: IUserFetchCriteriaModel): Promise<IGlobalEmployeeDetailGridDataModel> {
    let request: IRequest = {
      Url: "api/User/GetUsers",
      Body: filter
    };
    return this.post<IGlobalEmployeeDetailGridDataModel>(request);
  }
  getDuplicateUsersSearch(filter: IUserFetchCriteriaModel): Promise<IGlobalEmployeeDetailGridDataModel> {
    let request: IRequest = {
      Url: "api/User/GetDuplicateUsersByEmail",
      Body: filter
    };

    return this.post<IGlobalEmployeeDetailGridDataModel>(request);
  }
  
  getDuplicateUsers(filter: IUserFetchCriteriaModel): Promise<IGlobalEmployeeDetailGridDataModel> {
    let request: IRequest = {
      Url: "api/User/GetDuplicateUsers",
      Body: filter
    };

    return this.post<IGlobalEmployeeDetailGridDataModel>(request);
  }

  syncDuplicatedUsers(filter: IUserFetchCriteriaModel){
    let request: IRequest = {
      Url: "api/User/SyncDuplicateUsers",
      Body: filter
    };
    return this.post<IGlobalEmployeeDetailGridDataModel>(request);
  }

  getAPIUsers(filter: IUserFetchCriteriaModel): Promise<IGlobalEmployeeDetailGridDataModel> {
    var request: IRequest = {
      Url: "api/User/GetAPIUsers",
      Body: filter
    };

    return this.post<IGlobalEmployeeDetailGridDataModel>(request);
  }



  revertOverride(id: string): Promise<{}> {
    var request: IRequest = {
      Url: "api/GlobalEmployeeOverride/Revert",
      Body: `"${id}"`
    };

    return this.post(request);
  }

  getDictionaries(): Promise<IGlobalEmployeeDictionariesModel> {
    return this.get("api/User/Dictionaries");
  }
  getUserProfile(id: string): Promise<IUserProfileDataModel> {
    var request: IRequest = {
      Url: "api/GlobalEmployeeOverride/GetProfileData",
      Body: `"${id}"`
    };

    return this.post(request);
  }

  getOverrides(id: string): Promise<IGlobalEmployeeOverrideModel[]> {
    var request: IRequest = {
      Url: "api/GlobalEmployeeOverride/GetOverrides",
      Body: `"${id}"`
    };

    return this.post(request);
  }

  create(user: IGlobalEmployeeOverrideModel): Promise<IGlobalEmployeeOverrideModel[]> {
    var request: IRequest = {
      Url: "api/GlobalEmployeeOverride/Create",
      Body: user
    };

    return this.post(request);
  }

  createUserProfile(user: IGlobalEmployeeOverrideModel): Promise<boolean> {
    var request: IRequest = {
      Url: "api/GlobalEmployeeOverride/AddProfile",
      Body: user
    };

    return this.post(request);
  }

  createBulkUserProfile(userlist: IBulkProfileModel): Promise<IBulkProfileResultModel[]> {
    var request: IRequest = {
      Url: "api/GlobalEmployeeOverride/AddBulkProfiles",
      Body: userlist
    };
       
    return this.post(request);
  }

 
  downloadFile(): string {
    return "api/GlobalEmployeeOverride/GetExcelFile";
  }

  getCreateProfileAccessMasterdata(email: string): Promise<boolean> {
   
    var request: IRequest = {
      Url: "api/GlobalEmployeeOverride/GetCreateProfileAccessMasterdata",
      Body: `"${email}"`
    };

    return this.post(request);
  }

  addProfileLogs(action: string): Promise<{}>{
    var request: IRequest = {
      Url: "api/GlobalEmployeeOverride/AddProfileLogs",
      Body: `"${action}"`
    };

    return this.post(request);
  }

}
